export enum TipOptions {
  RECURRENT = 'RECURRENT',
  ONE_TIME = 'ONE_TIME',
}
